/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

class EmptyInputValidator extends HTMLElement {
  connectedCallback() {
    const input = this.querySelector('#customer-purchase-order-number');
    const submitButton = document.querySelector('[name="checkout"]');

    submitButton.disabled = true;
    submitButton.style.opacity = '30%';

    input.addEventListener('input', () => {
      if (input.value.trim() === '') {
        submitButton.disabled = true;
        submitButton.style.opacity = '30%';
      } else {
        submitButton.disabled = false;
        submitButton.style.opacity = '100%';
      }
    });
  }
}

customElements.define('empty-input-validator', EmptyInputValidator);

// [MAR 2024/2025] -- Annual spend limits, applies to specific tagged customer groups
(function () {
  const customerRollingSpend = document.querySelector(
    '[data-customer-rolling-spend]'
  );
  const submitButton = document.querySelector('[name="checkout"]');
  const rollingSpendAlert = document.getElementById('rolling-spend-alert');

  if (!customerRollingSpend) return;

  const spend = customerRollingSpend.dataset.customerRollingSpend * 100;
  const spendLimit = customerRollingSpend.dataset.customerSpendLimit * 100;

  const checkSpendAndCart = async () => {
    const getCartJson = async () => {
      try {
        const cartFetch = await fetch('/cart.js');
        const cartJson = await cartFetch.json();
        return cartJson;
      } catch (err) {
        console.error(err);
        return null;
      }
    };

    const cart = await getCartJson();
    const cartSubtotal = cart.items_subtotal_price;
    const spendAndCart = cartSubtotal + spend;

    console.log({ cartSubtotal, spendAndCart, spendLimit });

    if (spendAndCart > spendLimit) {
      rollingSpendAlert.style.display = 'block';
      submitButton.style.display = 'none';
    } else {
      rollingSpendAlert.style.display = 'none';
      submitButton.style.display = 'block';
    }
  };

  // listen for cart changes
  function observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(
          entry.initiatorType
        );
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          checkSpendAndCart();
        }
      });
    });
    cartObserver.observe({ entryTypes: ['resource'] });
  }

  // init
  checkSpendAndCart();
  observeCartChanges();
})();
